import { useRef } from "react";

// ThriftQuest lives in public/game as its own little app; we embed it here.
const GAME_URL = `${process.env.PUBLIC_URL}/game/index.html`;

export const Play = () => {
  const frame = useRef(null);

  // Fill the whole screen with the game; if the browser won't allow
  // fullscreen, open the game in its own tab instead.
  const goFullScreen = () => {
    frame.current.requestFullscreen().catch(() => window.open(GAME_URL));
  };

  return (
    <div className="play-page">
      <header className="page-header">
        <h1>ThriftQuest</h1>
        <p className="tagline">
          Every shelf hides a treasure — hunt the aisles, fill your cart, flip your finds.
        </p>
        <button className="fullscreen-btn" onClick={goFullScreen}>
          ⛶ Go full screen
        </button>
        <p className="fullscreen-hint">
          Press Esc to come back — or <a href={GAME_URL} target="_blank" rel="noreferrer">open the game in its own tab ↗</a>
        </p>
      </header>
      <iframe ref={frame} src={GAME_URL} title="ThriftQuest" className="game-frame" allow="fullscreen" />
    </div>
  );
};
